import updateFiltersExercisesAction from '../update-filters'
import EXERCISES_UI_ACTION from '../../constants/action'
import EXERCISES_UI_ANALYTICS_EVENT from '../../constants/analytics-event'
import EXERCISES_PATH from '../../constants/path'
import getEquipmentFiltersExercisesSelect from '../../selectors/get-equipment-filters'
import getMusclesFiltersExercisesSelect from '../../selectors/get-muscles-filters'
import getTypesFiltersExercisesSelector from '../../selectors/get-types-filters'
import setReduxAction from '../../../redux/actions/set'
import { logEventAnalyticsUtil } from '../../../../utils/analytics/log-event'

function resetFiltersExercisesAction (options = {}) {
  return (dispatch, getState) => {
    const typesFilters = getTypesFiltersExercisesSelector(getState())
    const musclesFilters = getMusclesFiltersExercisesSelect(getState())
    const equipmentFilters = getEquipmentFiltersExercisesSelect(getState())
    if (!typesFilters.length &&
      !musclesFilters.length &&
      !equipmentFilters.length) {
      return
    }
    dispatch(setReduxAction({
      type: EXERCISES_UI_ACTION.DELETE_FILTERS,
      payload: {
        paths: [
          EXERCISES_PATH.MUSCLE_FILTER,
          EXERCISES_PATH.TYPE_FILTER,
          EXERCISES_PATH.EQUIPMENT_FILTER
        ],
        values: [
          [],
          [],
          []
        ]
      }
    }))
    dispatch(updateFiltersExercisesAction())
    logEventAnalyticsUtil(options.analyticEvent ||
      EXERCISES_UI_ANALYTICS_EVENT.FILTERS_RESET)
  }
}

export default resetFiltersExercisesAction
